import gql from "graphql-tag";

export const UPDATE_TODOIST = gql`
  mutation ($input: updateTodoistInput) {
    updateTodoist(input: $input) {
      _id
    }
  }
`;
